import React from 'react';
import { CarouselSectionTypes, } from '../types';
import ImageSlide from '../ImageSlide';
import TextSlide from '../TextSlide';
import { ProductCard } from '../../ProductCard';
import { CardSlide } from '../CardSlide';
export const transformDecks = (decks) => {
    return decks.map((deck) => ({
        navTitle: deck.navTitle,
        cta: deck.cta,
        imageSlides: deck.imageSlides?.map((slide, index) => {
            const { src = '', ...rest } = slide.image ?? {};
            return (React.createElement(ImageSlide, { key: `${index}-${slide.imageTitle}`, image: { src, ...rest }, imageName: slide.imageName, imageTitle: slide.imageTitle, imageBio: slide.imageBio, renderLink: slide.renderLink }));
        }) || [],
    }));
};
export const transformSlides = (slides) => {
    return slides.reduce((acc, slide, index) => {
        if (!slide)
            return acc;
        const isDuplicate = acc.some((existingSlide) => existingSlide.key === slide._key);
        if (isDuplicate)
            return acc;
        if (slide.type === CarouselSectionTypes.Text) {
            acc.push(React.createElement(TextSlide, { key: slide._key ?? index, title: slide.title ?? '', body: slide.body ?? '', textVariant: slide.textVariant, cta: slide.cta, quoteName: slide.quoteName, quoteBio: slide.quoteBio, quoteText: slide.quoteText }));
        }
        else if (slide.type === CarouselSectionTypes.Image) {
            acc.push(React.createElement(ImageSlide, { key: slide._key ?? index, image: slide.image, imageName: slide.imageName, imageTitle: slide.imageTitle, imageBio: slide.imageBio, renderLink: slide.renderLink }));
        }
        else if (slide.type === CarouselSectionTypes.Product && slide.productData) {
            const productData = slide.productData;
            const imageProps = {
                loading: 'lazy',
                ...productData?.image,
            };
            const attributes = productData?.attributes
                ? Object.entries(productData.attributes).map(([key, value]) => ({
                    attribute: key.toUpperCase(),
                    values: value || [],
                }))
                : [];
            acc.push(React.createElement("div", { key: slide._key ?? index, className: "h-full md:min-h-[400px] [&>article]:!max-w-full" },
                React.createElement(ProductCard, { title: productData?.title, image: imageProps, tag: productData?.tag, price: productData?.price ?? '0.00', retailPrice: productData?.retailPrice, onAddToCart: productData?.onAddToCart, attributes: attributes, showPrice: productData.showPrice })));
        }
        else if (slide.type === CarouselSectionTypes.Education) {
            acc.push(React.createElement(CardSlide, { key: slide._key ?? index, title: slide.title, body: slide.body, linkWrapper: slide.linkWrapper }));
        }
        return acc;
    }, []);
};
